import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Desktop, Mobile } from './responsive';
import { Responsive, Spinner } from '~/components';
import { getSelectedMatchActsRequest } from '~/store/modules/matches/actions';
import EmptyPage from '~/pages/EmptyPage';

export default function ProtocolCommercialActs() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    selectedMatch: { data: selectedMatch },
    acts: { data: acts, loading },
    publicFiles,
  } = useSelector(state => state.matches);

  useEffect(() => {
    if (selectedMatch && Object.keys(acts).length === 0) {
      dispatch(getSelectedMatchActsRequest(selectedMatch.id));
    }
  }, [dispatch, selectedMatch, acts]);

  const actsProps = {
    publicFiles,
    acts,
  };

  if (loading) return <Spinner isOpen isRelative />;
  if (Object.keys(acts).length > 0) {
    return (
      <Responsive
        md={<Mobile {...actsProps} />}
        lg={<Desktop {...actsProps} />}
      />
    );
  }

  if (selectedMatch && selectedMatch.status === 'FullTime') {
    return <EmptyPage subtitle={t('emptySubtitleFullTime')} />;
  }

  return (
    <EmptyPage
      subtitle={t('emptySubtitleMatchRequest')}
      title={t('emptyTitleProtocol')}
    />
  );
}
